var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonVatten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.48,433.29A125.71,125.71,0,0,1,380.77,559c-69.43,0-124.85-56.29-125.72-125.71C254.21,365,318.64,288.55,380.77,208,440.16,284.39,506.48,363.86,506.48,433.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonVatten);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-vatten.79ebd9f67f1a32762c3165fd5d64cdf9.svg";
export { ForwardRef as ReactComponent };